import LengthDimensionCompoundGeometry from "../compoundSceneGeometry/LengthDimensionCompoundGeometry";
import LengthDimensionSubGeometry2d from "../compoundSceneGeometry/LengthDimensionSubGeometry2d";
import LengthDimensionSubGeometry3d from "../compoundSceneGeometry/LengthDimensionSubGeometry3d";
import SceneObjectTypeEnum from "../sceneObjectData/SceneObjectTypeEnum";
import ISceneGeometry from "./ISceneGeometry";

import RefLineGeometry from "./RefLineGeometry";
import TextAnnotationCompoundGeometry from "../compoundSceneGeometry/TextAnnotationCompoundGeometry";
import ChecklistItemCompoundGeometry from "../compoundSceneGeometry/ChecklistItemCompoundGeometry";
import ExtrudedLoopCompoundGeometry from "../compoundSceneGeometry/ExtrudedLoopCompoundGeometry";
import AreaAnnotationGeometry2d from "./AreaAnnotationGeometry2d";
import AreaAnnotationGeometry3d from "./AreaAnnotationGeometry3d";
import RectangleAnnotationGeometry2d from "./RectangleAnnotationGeometry2d";
import RectangleAnnotationGeometry3d from "./RectangleAnnotationGeometry3d";
import CircleAnnotationGeometry2d from "./CircleAnnotationGeometry2d";
import CircleAnnotationGeometry3d from "./CircleAnnotationGeometry3d";

export const createSceneGeometry = (type: SceneObjectTypeEnum): ISceneGeometry => {
    switch (type) {
        case SceneObjectTypeEnum.LengthDimension:
            return new LengthDimensionCompoundGeometry();
        case SceneObjectTypeEnum.RefLine:
            return new RefLineGeometry();
        case SceneObjectTypeEnum.TextAnnotation:
            //return new TextAnnotationGeometry();
            return new TextAnnotationCompoundGeometry();
        case SceneObjectTypeEnum.ChecklistItem:
            return new ChecklistItemCompoundGeometry();
        case SceneObjectTypeEnum.AreaAnnotation:
            return new ExtrudedLoopCompoundGeometry(new AreaAnnotationGeometry2d(), new AreaAnnotationGeometry3d());
        case SceneObjectTypeEnum.RectangleAnnotation:
            return new ExtrudedLoopCompoundGeometry(new RectangleAnnotationGeometry2d(), new RectangleAnnotationGeometry3d());
        case SceneObjectTypeEnum.CircleAnnotation:
            return new ExtrudedLoopCompoundGeometry(new CircleAnnotationGeometry2d(), new CircleAnnotationGeometry3d());
        default:
            throw new Error(`Unsupported scene object type: ${type}`);
    }
}

